module.exports = __webpack_public_path__ + "static/media/AAM-100.nologo_AAM.b9e45770.png";